// Sayfalama: sayfa başına 10/20/30/40 + 1,2,3... sayfa numaraları; marks: sayfa -> uyarı sayısı (kırmızı rozet)
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const PAGE_SIZES = [10, 20, 30, 40];

export const paginate = (list, page, size) => {
  const totalPages = Math.max(1, Math.ceil(list.length / size));
  const cur = Math.min(Math.max(1, page), totalPages);
  return { cur, totalPages, offset: (cur - 1) * size, rows: list.slice((cur - 1) * size, cur * size) };
};

export const TablePagination = ({ total, page, totalPages, pageSize, onPage, onPageSize, marks = {}, prefix }) => {
  if (!total) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 py-2" data-testid={`${prefix}-pagination`}>
      <div className="flex items-center gap-2 text-xs text-slate-600">
        <span>Sayfa başına</span>
        <Select value={String(pageSize)} onValueChange={(v) => { onPageSize(Number(v)); onPage(1); }}>
          <SelectTrigger className="h-8 w-[72px] text-xs" data-testid={`${prefix}-page-size`}><SelectValue /></SelectTrigger>
          <SelectContent>
            {PAGE_SIZES.map(s => <SelectItem key={s} value={String(s)} data-testid={`${prefix}-page-size-${s}`}>{s}</SelectItem>)}
          </SelectContent>
        </Select>
        <span data-testid={`${prefix}-page-info`}>Toplam {total} kayıt</span>
      </div>
      <div className="flex items-center gap-1">
        <Button type="button" variant="outline" size="sm" className="h-8 w-8 p-0" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${prefix}-page-prev`}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        {Array.from({ length: totalPages }, (_, i) => i + 1).map(n => (
          <Button
            key={n} type="button" size="sm" variant={n === page ? 'default' : 'outline'}
            className={`relative h-8 min-w-8 px-2 text-xs ${n === page ? 'bg-slate-800 hover:bg-slate-700' : ''} ${marks[n] ? 'border-red-400' : ''}`}
            onClick={() => onPage(n)} data-testid={`${prefix}-page-${n}`}
          >
            {n}
            {marks[n] > 0 && (
              <span className="absolute -top-1.5 -right-1.5 min-w-4 h-4 rounded-full bg-red-600 px-1 text-[10px] leading-4 text-white" data-testid={`${prefix}-page-mark-${n}`}>{marks[n]}</span>
            )}
          </Button>
        ))}
        <Button type="button" variant="outline" size="sm" className="h-8 w-8 p-0" disabled={page >= totalPages} onClick={() => onPage(page + 1)} data-testid={`${prefix}-page-next`}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
